export default "__VITE_ASSET__CGztWmJ6__"